import debounce from 'lodash/debounce'
import { useEffect } from 'react'
import { InsurerFormsType } from '@typesApp/Insurer'
import { config } from '@config/config'
import { useEnvironment } from './useEnvironment'
import { useInsurerConfiguration } from './useInsurerConfiguration'
import { useSessionInfo } from './useSessionInfo'

/**
 * Fetch initial configuration once session is ready
 */
export const useInitialConfiguration = () => {
  const { brand } = useEnvironment()
  const { isTokenReady, isLoggingOut, isSessionExpired } = useSessionInfo()

  const isReady = isTokenReady && !isLoggingOut && !isSessionExpired

  // NOTE: skip unless brand is initialized
  // we can remove this check once the insurerDetails API is also migrated to use api keys
  const { insurers, fetchInsurerConfiguration } = useInsurerConfiguration(!brand)

  useEffect(() => {
    const defaultInsurer = insurers?.find(i => i.dynamicFormsType === InsurerFormsType.DEFAULT) ?? insurers?.[0]
    if (defaultInsurer?.id && isReady && !config.getFeatures().disableInsurerConfigurationInitialFetch) {
      const debouncedHandler = debounce(() => {
        fetchInsurerConfiguration(defaultInsurer.id)
      })

      debouncedHandler()
      return () => debouncedHandler.cancel()
    }
  }, [fetchInsurerConfiguration, insurers, isReady])
}
